
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 3.155V5.36H6.291v12.64H14v2.206H4V3.155h10zm2.278 2.842l4.395 4.414c.21.212.327.495.327.796 0 .297-.12.588-.327.797l-4.395 4.414-1.545-1.594 2.486-2.497H10v-2.24h7.22l-2.487-2.496.3-.31.945-.975.3-.31z","fill":"#F2F4F8","fill-rule":"evenodd"}})])
          )
        }
      }
    